// extracted by mini-css-extract-plugin
module.exports = {"photoContents":"LazyPhotoImage_photoContents__2-c1L","fadein":"LazyPhotoImage_fadein__r5aXG","move":"LazyPhotoImage_move__2Tqw0","unFold":"LazyPhotoImage_unFold__2-hfn"};